export const ODLOZENE_SERVISNI_CINNOSTI = 'OdlozenaServisniCinnost';
export const DEPENDENT_TABLES = <const>[ODLOZENE_SERVISNI_CINNOSTI];
